import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import { useContext } from "react";
import DataContext from "../../../../../ContextServer/DataContext";
import { useNavigate } from "react-router-dom";

function PwCheckPopup({ open, handleClose }) {
  const {
    usrPhoneCheck,
    setUsrPhoneCheck,
    userPwdCheck,
    setUserPwdCheck,
    checkList,
    setCheckList,
    UserSecretCheck,
    seqno,
    setSeqno,
  } = useContext(DataContext);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: window.innerWidth < 600 ? "100%" : "90%",
    height: window.innerWidth < 600 ? "100vh" : 700,
    bgcolor: "background.paper",
    border: "2px solid #ffc55e",
    boxShadow: 24,
    p: 4,
  };

  const navigate = useNavigate();

  const handleButtonClick = () => {
    UserSecretCheck();
    setSeqno(checkList[0]?.seqno);
    navigate("/odor/declarelist/answer");
  };
  const handleChange = (e) => {
    setUserPwdCheck(e.target.value);
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleButtonClick();
    }
  };
  return (
    <div>
      <Modal
        open={open}
        onClose={() => {
          handleClose();
          setUsrPhoneCheck("");
          setUserPwdCheck("");
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div
            style={{
              width: "100%",
              height: "8vh",
              backgroundColor: "orange",
              textAlign: "center",
              borderRadius: "10px",
            }}
          >
            <h2 style={{ color: "white", paddingTop: "2vh" }}>사용자 확인</h2>
          </div>

          <div style={{ marginTop: "1vh", width: "100%", height: "100%" }}>
            <label>휴대폰번호*</label>
            <TextField
              type="number"
              fullWidth
              sx={{ textAlign: "center" }}
              helperText="- 을 뺀 나머지 번호를 입력해주세요."
              value={usrPhoneCheck}
              onChange={(e) => setUsrPhoneCheck(e.target.value)}
            />
            <br />

            <label>비밀번호*</label>
            <TextField
              type="password"
              fullWidth
              sx={{ textAlign: "center" }}
              helperText="민원신고시, 등록한 비밀번호를 입력해주세요."
              value={userPwdCheck}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
            />

            <Button
              variant="contained"
              type={"submit"}
              color={"info"}
              fullWidth
              sx={{ marginTop: 1 }}
              onClick={handleButtonClick}
            >
              확인
            </Button>
            <Button
              variant="contained"
              color={"inherit"}
              fullWidth
              sx={{ marginTop: 1 }}
              onClick={() => {
                handleClose();
                setUsrPhoneCheck("");
                setUserPwdCheck("");
              }}
            >
              돌아가기
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default PwCheckPopup;
